import { render, staticRenderFns } from "./BaseRightDoubleIcon.vue?vue&type=template&id=7237d691"
import script from "./BaseRightDoubleIcon.vue?vue&type=script&lang=js"
export * from "./BaseRightDoubleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports